module.exports = __webpack_public_path__ + "img/tree-08-e-trunk.54df75c1.png";